import {
    UIWidgetsDiv,
    UIWidgetsFlex,
    UIWidgetsDivGrid,
    UIWidgetsDivRound,
    UIWidgetsDivGridWrapper,
    UIWidgetsDivStretch,
    UIWidgetDivider
} from "./Division";
import DivHOC from "./Actions";

const Div = DivHOC(UIWidgetsDiv);
export const Flex = DivHOC(UIWidgetsFlex);
export const DivGrid = DivHOC(UIWidgetsDivGrid);
export const DivGridWrapper = DivHOC(UIWidgetsDivGridWrapper);
export const DivRound = DivHOC(UIWidgetsDivRound);
export const DivStretch = DivHOC(UIWidgetsDivStretch);
export const Divider = UIWidgetDivider;

export { default as DivHOC } from "./Actions";

export default Div;
